<template>
	<div>
		<v-chart class="my-chart" :options="line" @datazoom='onDataZoom($event,line)'/>
		<!-- <div>{{line}}</div> -->
	</div>

</template>

<script>
	import ECharts from 'vue-echarts'
	// import 'echarts/lib/chart/line'
	// import "echarts/lib/chart/bar";
	// import 'echarts/lib/component/polar'
	import Moment from 'moment'
	import {
		request_zzquant
	} from "network/request.js"

	var upColor = '#ec0000';
	// var upBorderColor = '#8A0000';
	// var downColor = '#00da3c';
	var downBorderColor = '#008F28';
	let dataZoomData = {
		"start": 50,
		"end": 100
	}

	export default {
		props: {
			title: {
				type: String,
				default: "市场情绪周期"
			},
			subText: {
				type: String,
				default: "题材周期"
			}
		},
		components: {
			'v-chart': ECharts
		},
		mounted() {
			this.refresh();
		},
		data() {
			return {
				line: {
					title: {
						text: this.title,
						subtext: this.subText,
						left: 0
					},
					color: [upColor, "#504f51", downBorderColor, "#504f51", "#5c74f0", "#5c74f0", "#5c74f0"],
					legend: {
						// data: ['最高板', '三连板', '面', '涨停板','跌停板','MA5','大长腿'],, '面', '大长腿'
						data: ['最高板', '三连板'],
					},
					grid: [{
							left: '5%',
							right: '5%',
							height: '50%'
						},
						{
							left: '5%',
							right: '5%',
							top: '70%',
							height: '20%'
						}
					],
					xAxis: [{
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: {
								onZero: false
							},
							splitLine: {
								show: false
							},
							splitNumber: 10,
							min: 'dataMin',
							max: 'dataMax',
							show: true,
							axisPointer: {
								z: 100
							},
							axisLabel: {
								fontSize: 10
							},
						},
						{
							gridIndex: 1,
							type: 'category',
							scale: true,
							// boundaryGap: false,
							axisLine: {
								onZero: false
							},
							splitLine: {
								show: false
							},
							splitNumber: 10,
							min: 'dataMin',
							max: 'dataMax',
							show: true,
							axisPointer: {
								z: 100
							},
							axisLabel: {
								fontSize: 10
							},
						}
					],
					yAxis: [{
							name: "最高板",
							scale: true,
							position: 'right',
							min: 0,
							max: 12,
							splitNumber: 10,
							splitLine: {
								show: true
								
							},
							splitArea: {
								show: true
							},
							axisLabel: {
								interval: 0,
								formatter: '{value}'
							},
						}, {
							name: "涨停",
							gridIndex: 1,
							scale: true,
							position: 'right',
							min: -150,
							max: 150,
							splitNumber: 10,
							splitLine: {
								show: false
							},
							splitArea: {
								show: true
							},
							axisLabel: {
								interval: 0,
								formatter: '{value}'
							},
						}, {
							scale: true,
							offset: 2,
							splitArea: {
								show: false
							},
							axisLine: {
								lineStyle: {
									color: '#DCDCDC',
									width: 1
								}
							},
							splitLine: false,
							position: 'left',
						},
					],
					dataZoom: [
						// {
						// 	type: 'inside',
						// 	// xAxisIndex: [0, 1],
						// 	start: dataZoomData.start,
						// 	end: dataZoomData.end
						// },
						{
							show: true,
							type: 'slider',
							xAxisIndex: [0, 1],
							y: '90%',
							start: dataZoomData.start,
							end: dataZoomData.end
						}
					],
					tooltip: {
						trigger: 'axis',
						formatter: function(params) {
							// console.log(params)
							var h = params[0].name + " <br />";
							params.forEach((item) => {
								var v = 0;
								if (item.seriesName == '涨停板') {
									// v = (this.value*100).toFixed(0);
									v = item.value[1];
								} else if (item.seriesName == '跌停板') {
									v = item.value[1];
								} else {
									v = item.value
								}
								if (item.seriesName == '三连板') {
									h += " <br />";
								} else {
									h += item.seriesName + ":" + v + " <br />";
								}
							});
							return h;
						}
					},
					// 提示联动
					axisPointer: {
						link: {xAxisIndex: 'all'},
						// label: {
						// 	backgroundColor: '#777'
						// }
					},
				}
			}
		},
		methods: {
			splitData(rawData) {
				let [categoryData,max_lb_num,lb_3_num,uplimit_num,downlimit_num,max_lb_stocks,damian_num,second_lb_num,fb_num,mian_num,bigleg_num ]= [[],[],[],[],[],[],[],[],[],[],[]];
				let [uplimit_num_m,downlimit_num_m ]= [[],[]];
				let [mark_line_mon, mark_line_day1] = [[],[]];
				let pre_month = -1;
				for (var i = 0; i < rawData.length; i++) {
					let item_date = rawData[i]['date1'];
					categoryData.push(rawData[i]['date1']);
					max_lb_num.push(rawData[i]['max_lb_num']);
					second_lb_num.push(rawData[i]['second_lb_num']);
					lb_3_num.push(rawData[i]['lb_3_num']);
					max_lb_stocks.push(rawData[i]['max_lb_stocks']);
					damian_num.push(rawData[i]['damian_num']);
					fb_num.push(rawData[i]['fb_num']);
					mian_num.push(rawData[i]['mian_num']);
					bigleg_num.push(rawData[i]['bigleg_num']);

					uplimit_num.push(rawData[i]['uplimit_num']);
					downlimit_num.push(rawData[i]['downlimit_num']);
					var uplimit = rawData[i]['uplimit_num']
					// uplimit = uplimit > 100 ? 100 : uplimit;
					uplimit_num_m.push([rawData[i]['date1'], uplimit, 1]);
					var downlimit = rawData[i]['downlimit_num'];
					// downlimit = downlimit > 100 ? 100 : downlimit;
					downlimit_num_m.push([rawData[i]['date1'], -downlimit, 1]);
					
					// 计算周一
					if(Moment(item_date).weekday()==1){
						mark_line_mon.push({
							xAxis:item_date,
							label: {formatter: item_date.substr(8)},
							})
					}
					if(Moment(item_date).month()!=pre_month){
						mark_line_day1.push({
							name:"月初", 
							label: {formatter: item_date.substr(5)},
							xAxis:item_date,
							})
						pre_month = Moment(item_date).month()
					}
				}
				return {
					categoryData: categoryData,
					max_lb_num: max_lb_num,
					second_lb_num: second_lb_num,
					lb_3_num: lb_3_num,
					uplimit_num: uplimit_num,
					downlimit_num: downlimit_num,
					downlimit_num_m: downlimit_num_m,
					uplimit_num_m: uplimit_num_m,
					max_lb_stocks: max_lb_stocks,
					damian_num: damian_num,
					fb_num: fb_num,
					mian_num: mian_num,
					bigleg_num: bigleg_num,
					mark_line_mon:mark_line_mon,
					mark_line_day1:mark_line_day1,
				};
			},
			calculateMA(dayCount, data) {
				var result = [];
				for (var i = 0, len = data.length; i < len; i++) {
					if (i < dayCount) {
						result.push('-');
						continue;
					}
					var sum = 0;
					for (var j = 0; j < dayCount; j++) {
						sum += data[i - j][1];
					}
					result.push(+(sum / dayCount).toFixed(2));
				}
				return result;
			},
			get_mark_point_data(data) {
				var point_data = [];
				for (var i = 0; i < data.lb_3_num.length; i++) {
					if (data.lb_3_num[i] <= 1) {
						point_data.push({
							name: '机会',
							value: data.lb_3_num[i],
							xAxis: data.categoryData[i],
							yAxis: data.max_lb_num[i]
						})
					}
				}
				return point_data
			},
			get_mark_point_data_damian(data) {
				var point_data = [];
				for (var i = 0; i < data.damian_num.length; i++) {
					if (data.damian_num[i] > 0) {
						point_data.push({
							name: '风险',
							value: data.damian_num[i],
							xAxis: data.categoryData[i],
							yAxis: data.max_lb_num[i]
						})
					}
				}
				return point_data
			},
			onDataZoom(event,option){
				if(event.type == 'datazoom'){
					let last_end = event.end
					if(event.start == 0){
						let data_start = Moment(option.xAxis[0].data[0])
						if(data_start <= Moment('2015-01-05')){
							return
						}
						let data_start_new = data_start.add(-1,'years').format("YYYY-MM-DD")
						// console.log(data_start_new)
						this.line.dataZoom[0].start=10
						this.line.dataZoom[0].end=last_end
						this.refresh(data_start_new)
					}
					
				}
				// console.log(option)
			},
			refresh(data_start) {
				// let url = '/sentiment/market/data?date1='
				let url = '/open/sentiment/data?date1='
				if(data_start){
					url += data_start
				}else{
					url += Moment().add(-1,'years').format('YYYY-MM-DD'); 
				}
				request_zzquant({
						url: url
					})
					.then(res => {
						let splitDataItem = this.splitData(res['data']['data']);
						let series_data = []
						series_data.push({
							name: '最高板',
							data: splitDataItem.max_lb_num,
							type: 'line',
							symbol: 'diamond',
							symbolSize: 8,
							showSymbol: true,
							markPoint: {
								symbol: 'circle',
								symbolSize: 12,
								symbolOffset: [0, 0],
								data: this.get_mark_point_data(splitDataItem),
							},
							label: {
								show: true,
								formatter: function(params) {
									return splitDataItem.max_lb_stocks[params.dataIndex];
								}
							},
							lineStyle: {
								normal: {
									width: 1,
									opacity: 1
								}
							},
							markLine:{
								symbol:'none',//去掉箭头
								lineStyle: {
									type:'solid',
									normal: {
										width: 2,
										opacity: 0.5,
									}
								},
								data: splitDataItem.mark_line_day1
							}
						});

						series_data.push({
							name: '三连板',
							data: splitDataItem.lb_3_num,
							type: 'line',
							showSymbol: false,
							
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.2
								}
							},
							symbol: 'circle',
						});
						series_data.push({
							name: '面',
							data: splitDataItem.mian_num,
							type: 'line',
							showSymbol: true,
							markPoint: {
								symbol: 'pin',
								symbolSize: 20,
								symbolOffset: [0, 20],
								data: this.get_mark_point_data_damian(splitDataItem),
							},
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.6
								}
							},
							symbol: 'circle',
						});

						series_data.push({
							name: '涨停板',
							data: splitDataItem.uplimit_num_m,
							type: 'bar',
							stack: "堆叠",
							xAxisIndex: 1,
							yAxisIndex: 1,
							// showSymbol: false,
							// xAxisIndex:0,
							label: {
								show: true,
								position: 'top',
								formatter: function(params) {
									return splitDataItem.uplimit_num[params.dataIndex];
								}
							},
							itemStyle: {
								normal: {
									width: 1,
									opacity: 0.8,
									color: upColor
								}
							},
							symbol: 'circle',
							markLine:{
								symbol:'none',//去掉箭头
								lineStyle: {
									type:'solid',
									normal: {
										width: 1,
										opacity: 0.5,
									}
								},
								data: splitDataItem.mark_line_mon
							}
						});
						series_data.push({
							name: '跌停板',
							data: splitDataItem.downlimit_num_m,
							type: 'bar',
							stack: "堆叠",
							xAxisIndex: 1,
							yAxisIndex: 1,
							// showSymbol: false,
							label: {
								show: true,
								position: 'bottom',
								formatter: function(params) {
									return splitDataItem.downlimit_num[params.dataIndex];
								}
							},
							itemStyle: {
								normal: {
									width: 1,
									opacity: 0.8,
									color: downBorderColor
								}
							},
							symbol: 'circle'
						});
						series_data.push({
							name: 'MA5',
							data: this.calculateMA(5, splitDataItem.uplimit_num_m),
							type: 'line',
							xAxisIndex: 1,
							yAxisIndex: 1,
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.7
								}
							},
							symbol: 'circle',
						});

						series_data.push({
							name: '大长腿',
							data: splitDataItem.bigleg_num,
							type: 'line',
							showSymbol: true,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.6
								}
							},
							symbol: 'circle',
						});

						//设置数据，这里要设置2个，否则下面一行数据不显示，或者不能拖动配合xAxisIndex
						this.line['xAxis'] = [{
							data: splitDataItem.categoryData,
						},
						{
							data: splitDataItem.categoryData,
						}];
						this.line['series'] = series_data;
						// this.line['legend'] = {
						// 	data: ['最高板', '三连板', '涨停板', '跌停板', '面', '大长腿'],
						// };
					})
			}
		}
	}
</script>

<style scoped>
.echarts {
	width: 100%;
	height: 600px;
}
</style>
